import React from 'react';
import { Chip } from '@mui/material';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import { ExpenseInvoiceDocumentKind } from '../Types/expenseInvoice.types';
import {
  EXPENSE_INVOICE_DOCUMENT_KIND_LABELS,
  normalizeExpenseInvoiceDocumentKind,
} from '../Utils/expenseInvoiceDocumentKind';

interface ExpenseInvoiceDocumentKindBadgeProps {
  documentKind: ExpenseInvoiceDocumentKind | 'FullInvoice' | 'SimplifiedCost' | string;
  size?: 'small' | 'medium';
}

export const ExpenseInvoiceDocumentKindBadge: React.FC<ExpenseInvoiceDocumentKindBadgeProps> = ({
  documentKind,
  size = 'small',
}) => {
  const normalizedKind = normalizeExpenseInvoiceDocumentKind(documentKind);

  if (normalizedKind === ExpenseInvoiceDocumentKind.SimplifiedCost) {
    return (
      <Chip
        size={size}
        color="secondary"
        variant="outlined"
        icon={<ConfirmationNumberOutlinedIcon fontSize="small" />}
        label={EXPENSE_INVOICE_DOCUMENT_KIND_LABELS[normalizedKind]}
      />
    );
  }

  return (
    <Chip
      size={size}
      color="primary"
      variant="outlined"
      icon={<ReceiptLongOutlinedIcon fontSize="small" />}
      label={EXPENSE_INVOICE_DOCUMENT_KIND_LABELS[normalizedKind]}
    />
  );
};

export default ExpenseInvoiceDocumentKindBadge;
